import Auth from "@aws-amplify/auth"
import Amplify from "@aws-amplify/core"

import util from './util';

var AmazonCognitoIdentity = require('amazon-cognito-identity-js');
var CognitoUserPool = AmazonCognitoIdentity.CognitoUserPool;

const Logger = Amplify.Logger
Logger.LOG_LEVEL = "DEBUG" // to show detailed logs from Amplify library
const logger = new Logger("store:auth")

// initial state
const state = {
    currentProduct: 'SmartPress',
    user: null,
    isAuthenticated: false,
    authenticationStatus: null,
    signupUser: null,
    getSession: new Promise( (resolve, reject) => {
        console.log(this)
        var data = { UserPoolId : 'us-east-2_6DIl412S8',
        ClientId : '395i5jceup4mjaippru3ek2huo' };

        var userPool = new AmazonCognitoIdentity.CognitoUserPool(data);
        var cognitoUser = userPool.getCurrentUser();

        if (cognitoUser != null) {

            cognitoUser.getSession(function(err, session) {


                if (err) {
                    // alert(JSON.stringify(err));
                    console.log(err)
                    return;
                }

                

                console.log('session validity: ' + session.isValid());

                if (!session.isValid()) {
                
                    console.log(session)

                    try {
                     cognitoUser.refreshSession(session.refreshToken, (err, session) => {
                        console.log('refreshed session', err, session);
                        resolve(session).then(function () {
                            location.reload(true);
                        })
                        // do whatever you want to do now :)
                      });
                    } catch (e) {
                      console.log('Unable to refresh Token', e);
                      resolve(session);
                    }

                    
                }
                console.log(session)
                resolve(session);
            });
        } else {
            console.log('else')
            resolve('failed');
        }
        // or
      // reject(new Error("Error!"));
    }),
}

const getters = {
    authenticatedUser: state => state.user,
    isAuthenticated: state => state.isAuthenticated,
    authenticationStatus: state => {
        return state.authenticationStatus
            ? state.authenticationStatus
            : { variant: "secondary" }
    },
    hasAuthenticationStatus: state => {
        return !!state.authenticationStatus
    }
}

const mutations = {
    setAuthenticationError(state, err) {
        logger.debug('auth error: {}', err)
        state.authenticationStatus = {
            state: 'failed', message: err.message, variant: 'danger',
        }
    },
    clearAuthenticationStatus: (state) => {
        state.authenticationStatus = null
    },
    setSignupData: (state, user) => {
        state.signupUser = user
    },
    setUserAuthenticated(state, user) {
        state.user = user
        state.isAuthenticated = true
    },
    clearAuthentication(state) {
        state.user = null
        state.userId = null
        state.isAuthenticated = false
    },
    changeCurrentProduct(state, product) {
        state.currentProduct = product
    }
}

const actions = {
    changeProducts: (context, params) => {
        console.log(params)
        context.commit('changeCurrentProduct', params.product)
    },
    clearAuthenticationStatus: (context) => {
        context.commit('clearAuthenticationStatus', null)
    },
    signIn: async (context, params) => {
        logger.debug('signIn for {}', params.username)
        context.commit('auth/clearAuthenticationStatus', null, { root: true })
        try {
            
            const user = await Auth.signIn(params.username, params.password)
            console.log(user)
            context.commit('setUserAuthenticated', user)
        }
        catch (err) {
            context.commit('auth/setAuthenticationError', err, { root: true })
        }
    },
    signOut: async (context) => {
        try {
            await Auth.signOut()
        } catch (err) {
            logger.error('error during sign out: {}', err)
        }
        
        context.commit('auth/clearAuthentication', null, { root: true })
        context.commit('contractsDb/clearData', null, { root: true })
        context.commit('eosJsFunc/clearData', null, { root: true })
    },
    signUp: async (context, params) => {
        context.commit('auth/clearAuthenticationStatus', null, { root: true })
        try {
            await Auth.signUp(params)
            context.commit('auth/setSignupData', params, { root: true })
            context.commit('auth/clearAuthentication', null, { root: true })
        } catch (err) {
            context.commit('auth/setAuthenticationError', err, { root: true })
        }
    },
    confirmSignUp: async (context, params) => {
        logger.debug('confirm signup for {}', params.username)
        context.commit('auth/clearAuthenticationStatus', null, { root: true })
        try {
            await Auth.confirmSignUp(params.username, params.code)
        } catch (err) {
            context.commit('auth/setAuthenticationError', err, { root: true })
        }
    },
    confirmResend: async (context, params) => {
        context.commit('auth/clearAuthenticationStatus', null, { root: true })
        try {
            await Auth.resendSignUp(params.username)
        } catch (err) {
            context.commit('auth/setAuthenticationError', err, { root: true })
        }
    },
    passwordReset: async (context, params) => {
        context.commit('auth/clearAuthenticationStatus', null, { root: true })
        try {
            await Auth.forgotPassword(params.username)
        } catch (err) {
            context.commit('auth/setAuthenticationError', err, { root: true })
        }
    },
    confirmPasswordReset: async (context, params) => {
        context.commit('auth/clearAuthenticationStatus', null, { root: true })
        try {
            await Auth.forgotPasswordSubmit(params.username, params.code, params.password)
        } catch (err) {
            context.commit('auth/setAuthenticationError', err, { root: true })
        }
    },
    passwordResetResend: async (context, params) => {
        context.commit('auth/clearAuthenticationStatus', null, { root: true })
        try {
            await Auth.passwordResetResend(params.username)
        } catch (err) {
            context.commit('auth/setAuthenticationError', err, { root: true })
        }
    },
    passwordChange: async (context, params) => {
        logger.debug('password change for {}', context.state.user.username)
        context.commit('auth/clearAuthenticationStatus', null, { root: true })
        try {
            const user = await Auth.currentAuthenticatedUser()
            await Auth.changePassword(user, params.currentPassword, params.newPassword)
        } catch (err) {
            context.commit('auth/setAuthenticationError', err, { root: true })
        }
    },
    getCurrentUser: state => {
        var data = { UserPoolId : 'us-west-2_pRFibQoUB',
        ClientId : '3a8sr0t0akpaktsjnmg1i7tr52' };
        var userPool = new AmazonCognitoIdentity.CognitoUserPool(data);
        var cognitoUser = userPool.getCurrentUser();

        if (cognitoUser != null) {
            cognitoUser.getSession(function(err, session) {
                if (err) {
                    alert(JSON.stringify(err));
                    return;
                }
                console.log('session validity: ' + session.isValid());
                return session
            });
        } else {
            console.log('else')
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}